import React, {memo} from 'react';
import PropTypes from "prop-types"
import {Circle, GoogleMap, InfoWindow, Marker, Polygon, Polyline, Rectangle,} from 'react-google-maps'
import {getColorIcon, getLabel} from "../IconProvider";
import {Link} from "react-router";
import PolygonModal from "./PolygonModal";
import {checkRectangleCoordinates, colors, defaultMapParams, fitBounds} from "../../../common/commonHandlers";
import ResourceComponent from "../../../components/ResourceComponent";
import {Button, Col, Row} from "react-bootstrap";
import Attachment from "../../../components/image/Attachment";
import createApiService from "../../../common/clientActionsBuilder";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import './MapViewPage.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle, faLock, faLockOpen, faMapMarkerAlt, faRuler} from "@fortawesome/free-solid-svg-icons";
import PlantName from "../../../components/PlantName";
import {GoogleMapLoader} from "../../../components/GoogleMapLoader";
import MDSpinner from "react-md-spinner";
import _ from 'lodash'
import {getBasicMarker} from "../../../utilities";
import MemoizedMarker from "./MemoizedMarker";
import dot from '../../CrewWorkOrdersPage/dot.png'
import {geolocated} from "react-geolocated";
import ColorCheckbox from "../../Scheduler/ColorCheckbox";
import {getUserShowLocation, setUserShowLocation} from "./MapActions";
import {withMediaQuery} from '../../../utilities/hooks/useMediaQuery';
import DrawingManager, {MAP_DRAWING_MODES} from "../../../components/GoogleMapsDrawingManager";


const google = window.google;

const api = createApiService('polygons', 'polygons', 'Polygon');

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

const areAssetsEquals = (prev, next) => {
    if (prev.loaded !== next.loaded) return false;
    if (prev.spriteUrl !== next.spriteUrl) return false;
    if (prev.markerOrigins !== next.markerOrigins) return false;
    if (prev.siteAssets !== next.siteAssets) {
        if (!prev.siteAssets || !next.siteAssets || prev.siteAssets.length !== next.siteAssets.length) return false;
        const keysToCompare = ["id", "selected", "latitude", "longitude", "asset_number", "label"];
        for (let i = 0; i < prev.siteAssets.length; i++) {
            for (const key of keysToCompare) {
                if (prev.siteAssets[i][key] !== next.siteAssets[i][key]) return false;
            }
        }
    }
    return true;
}


class Map extends ResourceComponent {
    constructor(props) {
        super(props);
        this._refs = {};
        this._drawingHandlers = {};
    }

    static propTypes = {
        site: PropTypes.object,
        siteAssets: PropTypes.array,
        editable: PropTypes.bool,
        onMarkerEdit: PropTypes.func.isRequired,
        onMarkerAdd: PropTypes.func.isRequired,
        onMarkersAdd: PropTypes.func.isRequired,
        onMarkerClick: PropTypes.func.isRequired,
        onDragend: PropTypes.func.isRequired,
        loaded: PropTypes.object,
        myLocationCheckbox: PropTypes.bool,
        spriteUrl: PropTypes.object,
        markerOrigins: PropTypes.object,
    };

    state = {
        distance: null,
        position: null,
        polyLine: null,
        drawingMode: null,
        polygonModal: null,
        polygonClick: null,
        duplicates: [],
        loaded: false,
        onHidePolygonModal: false,
        mapParams: null,
        refresh: true,
        polygonInfoWindow: [],
        isMapLoaded: false,
        showLegend: false,
        isMapView: true,
        lockedMode: this.props.lockedMode,
        myLocationMarker: null,
        showMyLocation: false,
        locationStatusLoaded: false,
        checkboxLoading: false,
    };

    shapeRefs = {};

    shouldReload = (nextProps) => {
        return this.props.loaded && nextProps.loaded &&
            this.props.loaded.valueOf() !== nextProps.loaded.valueOf();
    };

    isCompleted = (asset) => {
        return !!asset.completed_at
    }

    componentWillReceiveProps = (nextProps) => {
        const {siteAssets, site, proposalPolygon} = this.props;
        const firstAssetAdded = site && nextProps.site
            && site.id === nextProps.site.id
            && siteAssets && nextProps.siteAssets
            && siteAssets.length === 0 && nextProps.siteAssets.length > 0;
        if (this.props.newAsset) {
            const asset = siteAssets.find((a) => a.id === this.props.newAsset.id)
            const index = siteAssets.indexOf(asset)
            siteAssets[index] = this.props.newAsset
            this.setState({siteAssets: siteAssets});
        }
        if (this.props.opacity) {
            const site = siteAssets.find((val) => val.id === this.props.opacity.id)
            const index = siteAssets.indexOf(site)
            siteAssets[index].opacity = this.props.opacity.val
            this.setState({siteAssets: siteAssets});
        }
        if (firstAssetAdded) {
            this.setState({loaded: false, proposalPolygon}, this.reloadMapParams);
        }
        if (!_.isEqual(siteAssets, nextProps.siteAssets) && nextProps.siteAssets.length === 0) {
            this.setState({siteAssets: siteAssets, isMapLoaded: false});
        }
        if (!_.isEqual(nextProps.siteAssets?.map(a => a.id)?.sort(), siteAssets?.map(a => a.id)?.sort())) {
            this.reloadMapParams(undefined, false)
        }
        if (this.shouldReload(nextProps) && site?.id === nextProps.site?.id) {
            this.setState({loaded: false, proposalPolygon}, () => this.reloadMapParams(undefined, false));
        }
        if (!this.props.coords && nextProps.coords && !this.state.myLocationMarker) {
            this.setState({
                myLocationMarker: {
                    latitude: nextProps.coords.latitude,
                    longitude: nextProps.coords.longitude
                }
            })
        }
        if (!this.state.locationStatusLoaded) {
            this.props.actions.getUserShowLocation(() => {
                this.setState({locationStatusLoaded: true})
            });
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {fullScreen, siteAssets} = this.props;
        const {isMapView} = this.state;

        if (prevProps.site?.id !== this.props.site?.id) {
            this.reloadMapParams()
        }

        if (prevProps.fullScreen !== fullScreen && fullScreen) {
            this.reloadMapParams()
        } else if (prevProps.fullScreen !== fullScreen && !fullScreen) {
            this.reloadMapParams()
        }

        if ((prevState.isMapView !== isMapView) && isMapView) {
            this.props.setStreetView(!isMapView)
        }
        if (!isMapView && this.state.mode === 'duplication') {
            this.finishDuplication()
        }

        if (prevProps.lockedMode !== this.props.lockedMode) {
            this.setState({lockedMode: this.props.lockedMode})
        }
        if (prevProps.active !== this.props.active) {
            this.reloadMapParams()
        }
        if (prevState.showMyLocation !== this.state.showMyLocation) {
            this.reloadMapParams()
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const stateKeys = Reflect.ownKeys(nextState);
        let stateChanged = false;
        for (const key of stateKeys) {
            if (this.state[key] !== nextState[key]) {
                stateChanged = true;
                break;
            }
        }
        if (stateChanged) return true;

        if (nextProps.site?.id !== this.props.site?.id) return true;
        if (nextProps.lockedMode !== this.props.lockedMode) return true;
        if (nextProps.siteAssets !== this.props.siteAssets) return true;
        if (nextProps.spriteUrl !== this.props.spriteUrl) return true;
        if (nextProps.markerOrigins !== this.props.markerOrigins) return true;
        if (nextProps.editable !== this.props.editable) return true;
        if (nextProps.showLabels !== this.props.showLabels) return true;
        if (nextProps.showNewAssets !== this.props.showNewAssets) return true;
        if (nextProps.fullScreen !== this.props.fullScreen) return true;
        if (nextProps.anyMoved !== this.props.anyMoved) return true;
        if (nextProps.asset !== this.props.asset) return true;

        return false;
    }


    componentDidMount() {
        this.reloadMapParams();
    }

    componentWillUnmount() {
        this.cleanupDrawingHandlers();
    }

    detectClick = (number) => {
        if (!Number.isInteger(number) || number < 1) return null;

        const mapContainer = document.getElementById('leadMap');
        if (!mapContainer) return null;

        const gmButtons = mapContainer.querySelectorAll(
            '[role="button"][class^="gm-"], [role="button"][class*=" gm-"]'
        );

        if (gmButtons.length >= number) {
            return gmButtons[number - 1];
        }

        const drawingControl = mapContainer.querySelector(
            '.gm-drawing-manage, .gm-drawing-controls'
        );

        if (!drawingControl) return null;

        const drawingButtons = drawingControl.querySelectorAll('[role="button"]');

        return drawingButtons[number - 1] || null;
    };

    cleanupDrawingHandlers = () => {
        for (let i = 1; i <= 6; i++) {
            if (this._drawingHandlers[i]) {
                try {
                    this._drawingHandlers[i].element.removeEventListener('click', this._drawingHandlers[i].handler);
                } catch (e) {
                    console.debug('Drawing handler element already removed from DOM', e.message);
                }
                delete this._drawingHandlers[i];
            }
        }
    };

    setupDrawingHandlers = () => {
        this.cleanupDrawingHandlers();
        for (let i = 1; i <= 6; i++) {
            let dm = this.detectClick(i);
            if (dm) {
                this._drawingHandlers[i] = {
                    element: dm,
                    handler: () => this.setState({
                        mode: null,
                        drawingMode: this.handleMarkerType(i)
                    })
                };
                dm.addEventListener('click', this._drawingHandlers[i].handler);
            }
        }
    };

    handleMarkerType = (i) => {
        let result = null
        switch (i) {
            case 2:
                result = MAP_DRAWING_MODES.MARKER
                break;
            case 3:
                result = MAP_DRAWING_MODES.POLYLINE
                break;
            case 4:
                result = MAP_DRAWING_MODES.POLYGON
                break;
            case 5:
                result = MAP_DRAWING_MODES.RECTANGLE
                break;
            case 6:
                result = MAP_DRAWING_MODES.CIRCLE
                break;
            default:
                result = null
        }
        return result
    }

    toggleInfoWindow = () => {
        this.state.polyLine.setMap(null);
        this.setState({distance: null, polyLine: null})
    };
    onMeasureComplete = polyLine => {
        if (this.state.mode === 'duplication') {
            this.finishDuplication()
        }
        let path = polyLine.getPath();
        let totalDistance = google.maps.geometry.spherical.computeLength(path)
        totalDistance *= 3.28084;
        this.setState({
            distance: totalDistance.toFixed(2).toString() + ' ft.',
            position: {
                lat: path.getArray()[0].lat(),
                lng: path.getArray()[0].lng(),
            },
            polyLine: polyLine,
        })
    };

    onPolyLineComplete = polyLine => {
        if (this.state.mode === 'duplication') {
            this.finishDuplication()
        }
        let path = polyLine.getPath();

        const drawValue = path.getArray().map((p) => ({
            latitude: p.lat(),
            longitude: p.lng(),
            id: null,
        }))
        const resource = {
            color: 1,
            type_polygon: 'polyLine',
            polygon_points_attributes: drawValue
        }

        let selectedAssetVal = null
        selectedAssetVal = this.getAssetValues('polyLine', polyLine)
        this.setState({selectedAssetVal: selectedAssetVal});
        this.props.onPolygonAdd({
            latitude: path.getArray()[0].lat(),
            longitude: path.getArray()[0].lng(),
            polygons: resource
        }, selectedAssetVal);

        polyLine.setMap(null)
    };
    drawingSave = (draw) => {
        if (this.state.mode === 'duplication') {
            this.finishDuplication()
        }
        const path = draw.getPath();

        if (path.getLength() < 3) {
            draw.setMap(null);
        } else {
            const drawValue = path.getArray().map((p) => ({
                latitude: p.lat(),
                longitude: p.lng(),
                id: null,
            }))
            let selectedAssetVal = null
            selectedAssetVal = this.getAssetValues('polygon', draw)
            this.setState({selectedAssetVal: selectedAssetVal});
            const resource = {
                type_polygon: 'polygon',
                polygon_points_attributes: drawValue
            }
            this.props.onPolygonAdd({
                ...drawValue[0],
                polygons: resource
            }, selectedAssetVal);
            draw.setMap(null)
        }
    }
    drawCircle = (draw) => {
        if (this.state.mode === 'duplication') {
            this.finishDuplication()
        }
        const resource = {
            type_polygon: 'circle',
            radius: draw.radius,
            polygon_points_attributes: [{
                latitude: draw.center.lat(),
                longitude: draw.center.lng(),
            }]
        }
        let selectedAssetVal = null
        selectedAssetVal = this.getAssetValues('circle', draw)
        this.setState({selectedAssetVal: selectedAssetVal});
        this.props.onPolygonAdd({
            latitude: draw.center.lat(),
            longitude: draw.center.lng(),
            polygons: resource,
        }, selectedAssetVal);
        draw.setMap(null)
    }
    drawRectangle = (draw) => {
        if (this.state.mode === 'duplication') {
            this.finishDuplication()
        }
        const path = draw.getBounds();
        const northEast = path.getNorthEast();
        const southWest = path.getSouthWest();
        const polygon_points_attributes = [
            {latitude: northEast.lat(), longitude: southWest.lng()},
            {latitude: northEast.lat(), longitude: northEast.lng()},
            {latitude: southWest.lat(), longitude: northEast.lng()},
            {latitude: southWest.lat(), longitude: southWest.lng()}
        ]
        let selectedAssetVal = null
        selectedAssetVal = this.getAssetValues('rectangle', draw)
        this.setState({selectedAssetVal: selectedAssetVal});
        const resource = {
            label: 'New layer',
            type_polygon: 'rectangle',
            polygon_points_attributes: polygon_points_attributes
        }
        this.props.onPolygonAdd({
            ...polygon_points_attributes[0],
            polygons: resource
        }, selectedAssetVal);
        draw.setMap(null)
    }

    refresh = () => {
        this.setState({refresh: true})
    }

    deletePolygon = (resource) => {
        const filterPolygon = this.state.proposalPolygon.site.filter((polygon) => polygon.id !== resource.id)
        this.setState({proposalPolygon: {site: filterPolygon}, polygonClick: null})
        this.props.actions.remove(resource)
    }
    getSelectedAssets = () => {
        const {siteAssets} = this.props;
        return siteAssets.filter(a => a.selected);
    };

    finishDuplication = (callback) => {
        const duplicates = this.state.duplicates;
        this.setState({
            duplicates: [],
            editable: false,
            drawingMode: null,
            mode: null,
            selectedAsset: undefined
        }, () => {
            duplicates.forEach(x => {
                google.maps.event.clearInstanceListeners(x);
                x.setMap(null);
            });
            callback && callback(duplicates, this.getSelectedAssets()[0].id);
        })
    };

    onDragend = (ass) => (e) => {
        if (this.state.mode === 'duplication') {
            this.finishDuplication()
        }
        this.setState({drawingMode: null});
        this.props.onDragend(ass.id, e);
    };

    stopDrawing = () => this.state.drawingMode && this.setState({drawingMode: null});

    onCircleMove = (ass) => {
        const polygon = ass.polygons.find(p => p.chosen)
        const circle = this.shapeRefs[ass.id]
        if (!circle) return
        const center = circle.getCenter()
        const point = polygon.polygon_points[0];
        if (center.lat() === point.lat && center.lng() === point.lng) return;
        const polygon_points_attributes = [{
            id: polygon.polygon_points[0].id,
            latitude: center.lat(),
            lat: center.lat(),
            longitude: center.lng(),
            lng: center.lng(),
        }]
        this.props.onDragendCircle(ass.id, center, polygon_points_attributes);
    };

    onCircleEdit = (ass) => {
        const circle = this.shapeRefs[ass.id]
        if (!circle) return
        const polygon = ass.polygons.find(p => p.chosen);
        if (circle.getRadius() === Number(polygon.radius)) return;
        const selectedAssetVal = this.getAssetValues('circle', circle)
        this.props.onCircleEdit(selectedAssetVal, ass.id, circle.getRadius())
        this.setState({selectedAssetVal});
    };

    onShapeChange = (ass, assetType) => {
        const shape = this.shapeRefs[ass.id]
        if (!shape) return
        const polygon = ass.polygons.find(p => p.chosen)
        const valueOld = polygon.polygon_points;
        const selectedAssetVal = this.getAssetValues(assetType || polygon.type_polygon, shape)
        const isRectangle = !shape.getPath
        if (isRectangle) {
            const path = shape.getBounds();
            const northEast = path.getNorthEast();
            const southWest = path.getSouthWest();
            const polygon_points_attributes = [
                {
                    latitude: northEast.lat(),
                    lat: northEast.lat(),
                    longitude: southWest.lng(),
                    lng: southWest.lng(),
                    id: valueOld[0].id
                },
                {
                    latitude: northEast.lat(),
                    lat: northEast.lat(),
                    longitude: northEast.lng(),
                    lng: northEast.lng(),
                    id: valueOld[1].id
                },
                {
                    latitude: southWest.lat(),
                    lat: southWest.lat(),
                    longitude: northEast.lng(),
                    lng: northEast.lng(),
                    id: valueOld[2].id
                },
                {
                    latitude: southWest.lat(),
                    lat: southWest.lat(),
                    longitude: southWest.lng(),
                    lng: southWest.lng(),
                    id: valueOld[3].id
                }
            ]

            const anyMoved = polygon_points_attributes.some((currentValue, i) =>
                !valueOld[i] || currentValue.latitude !== valueOld[i].lat || currentValue.longitude !== valueOld[i].lng
            )
            if (anyMoved) {
                this.props.onDragendPoly(selectedAssetVal, ass.id, polygon_points_attributes);
            }
        } else {
            const value = shape.getPath().getArray().map((p, i) => ({
                latitude: p.lat(),
                longitude: p.lng(),
                lat: p.lat(),
                lng: p.lng(),
                id: polygon.polygon_points[i] && polygon.polygon_points[i].id,
            }))
            const anyMoved = value.some((currentValue, i) =>
                !valueOld[i] || currentValue.latitude !== valueOld[i].lat || currentValue.longitude !== valueOld[i].lng
            )
            if (anyMoved) {
                if (polygon.type_polygon === 'rectangle') {
                    this.props.onDragendPoly(selectedAssetVal, ass.id, value, 'polygon');
                } else {
                    this.props.onDragendPoly(selectedAssetVal, ass.id, value);
                }
            }
        }

        this.setState({selectedAssetVal});

    };

    sqft = (val) => {
        val *= 10.7639104;
        return val.toFixed(2)
    }

    ft = (val) => {
        val *= 3.28084;
        return val.toFixed(2)
    }
    onMarkerClick = (ass, type) => {
        const shape = type ? this.shapeRefs[ass.id] : null;
        if (type && !shape) return;
        if (this.state.duplicates.length) {
            this.setState({mode: 'duplication', drawingMode: 'marker'});
        }
        const selectedAssetVal = this.getAssetValues(type, shape)
        this.setState({selectedAsset: ass.id, selectedAssetVal});
        this.props.onMarkerClick(ass.id, {
            mode: this.state.duplicates.length ? 'duplication' : this.state.mode,
            drawingMode: this.state.duplicates.length ? 'marker' : null,
            selectedAsset: ass.id,
            selectedAssetVal
        });
    };

    onSteetViewChange = (siteAssets) => {
        siteAssets.forEach(asset => {
            if (asset.polygons?.length > 0) {
                const polygon = asset.polygons.find(p => p.chosen)
                const center = {}

                const coords = polygon.polygon_points.map(({lat, lng}) => ({lat, lng}))

                const xValues = coords.map(({lat}) => lat)
                const yValues = coords.map(({lng}) => lng)

                const x1 = Math.min.apply(Math, xValues)
                const x2 = Math.max.apply(Math, xValues)

                const y1 = Math.min.apply(Math, yValues)
                const y2 = Math.max.apply(Math, yValues)

                center.lat = x1 + ((x2 - x1) / 2);
                center.lng = y1 + ((y2 - y1) / 2);

                asset.lat = center.lat
                asset.lng = center.lng

                asset.opacity = false
            } else {
                asset.lat = asset.latitude
                asset.lng = asset.longitude
            }
        })
    }

    reloadMapParams = (callback, centerMap = true) => {
        const {
            site,
            siteAssets,
            client,
        } = this.props;

        let coordinates = [];
        siteAssets.forEach(asset => {
            if (asset.polygons && asset.polygons.length > 0) {
                const polygon = asset.polygons.find(p => p.chosen)
                for (let p of polygon.polygon_points) {
                    coordinates.push({latitude: p.lat, longitude: p.lng});
                }
            } else if (asset.polygons && asset.polygons.length === 0 && asset.latitude && asset.longitude) {
                asset.lat = asset.latitude
                asset.lng = asset.longitude
                coordinates.push({latitude: asset.lat, longitude: asset.lng});
            }
        })
        const {center, myLocationMarker, showMyLocation} = this.state;
        let mapParams
        if (siteAssets.length === 0) {
            mapParams = {tilt: 0, defaultMapTypeId: 'hybrid', gestureHandling: 'greedy', defaultZoom: 4}
        } else {
            mapParams = defaultMapParams(siteAssets, center, null, client);
        }

        if (centerMap) {
            if (site && coordinates.length === 0 && !showMyLocation) {
                mapParams.center = {lat: site.latitude, lng: site.longitude};
                mapParams.zoom = 18;
            } else {
                if (this.map) {
                    if (showMyLocation && myLocationMarker) {
                        setTimeout(() => fitBounds(this.map, [...coordinates, {
                            latitude: myLocationMarker.latitude,
                            longitude: myLocationMarker.longitude
                        }]), 0);
                    } else {
                        setTimeout(() =>
                                fitBounds(this.map, coordinates)
                            , 0);
                    }
                    this.setState({isMapLoaded: true})
                }
            }
        }
        this.setState({mapParams}, callback);

    };

    onHidePolygonModal = (val) => {
        this.setState({onHidePolygonModal: !this.state.onHidePolygonModal, polygonModal: val})
    }

    infoWindow = (ass, lat, lng) => {
        const {mode} = this.state;
        const {onMarkerEdit, onMarkersAdd, anyMoved} = this.props;
        const selectedAssets = this.getSelectedAssets().map(x => x.id);

        if (selectedAssets.includes(ass.id) && this.state.selectedAsset !== null) {
            if (ass.image_order) {
                let order = JSON.parse(ass.image_order);
                ass.images = ass.images.map(img => {
                    img.order = order.findIndex((o) => o === img.id)
                    return img
                })
            } else {
                ass.images = ass.images.map((img, index) => {
                    img.order = index
                    return img
                })
            }
            return (
                <InfoWindow
                    key={this.state.selectedAsset}
                    position={{lat: lat ? lat : ass.latitude, lng: lng ? lng : ass.longitude}}
                    onCloseClick={() => this.setState({selectedAsset: null})}>
                    <div className="info-window no_white-space">
                        {mode === 'duplication' &&
                            <div>Creating duplicates of: <br/>
                                <b><PlantName plant={ass.plant_name}/></b><br/>
                                <Link className="small-padding pointer" style={{color: '#1a664f'}}
                                      onClick={() => {
                                          this.finishDuplication((duplicates, selectedAsset) => {
                                              onMarkersAdd(selectedAsset, duplicates);
                                              this.props.resetMovedAssets();
                                          });
                                      }}>
                                    Save
                                </Link>
                                <Link className="small-padding pointer" style={{color: 'red'}}
                                      onClick={() => {
                                          this.finishDuplication();
                                      }}>
                                    Cancel
                                </Link>
                            </div>}
                        {mode !== 'duplication' &&
                            <div>
                                <Row>

                                    {ass.images.filter(p => p.cwo_and_proposal_display === true).length > 0 &&
                                        <Col md={4}>
                                            {ass.images.filter(p => p.cwo_and_proposal_display === true).sort((a, b) => a.order - b.order).slice(0, 1).map(i =>
                                                <Attachment key={i.id}
                                                            image={i}
                                                />)}
                                        </Col>}
                                    <Col md={8}>
                                        <b>#{ass.label}{" "}<PlantName plant={ass.plant_name}/></b><br/>
                                        {ass.plant_dbh ? `DBH: ${ass.plant_dbh}"` : ""}
                                        {ass.plant_dbh ? <br/> : null}
                                        <Link disabled={anyMoved} className="small-padding pointer"
                                              style={{color: anyMoved ? 'gray' : 'red'}}
                                              onClick={() => {
                                                  onMarkerEdit(ass, this.state.selectedAssetVal);
                                              }}>
                                            Edit
                                        </Link>
                                        {(ass.polygons.length > 0 && !this.state.lockedMode) ? mode === 'resize' ?
                                            <Link className="small-padding pointer" style={{color: 'red'}}
                                                  onClick={() => {
                                                      this.setState({
                                                          editable: false,
                                                          mode: null
                                                      })
                                                  }}
                                            >
                                                Stop resizing
                                            </Link>
                                            :
                                            <Link className="small-padding pointer" style={{color: 'red'}}
                                                  onClick={() => {
                                                      this.setState({
                                                          editable: true,
                                                          drawingMode: null,
                                                          mode: 'resize'
                                                      })
                                                  }}
                                            >
                                                Modify
                                            </Link> : null
                                        }

                                        <Link className="small-padding pointer" style={{color: 'red'}}
                                              onClick={() => {
                                                  this.setState({
                                                      editable: true,
                                                      drawingMode: 'marker',
                                                      mode: 'duplication'
                                                  })
                                              }
                                              }
                                        >
                                            Duplicate
                                        </Link>
                                    </Col>
                                </Row>
                            </div>}
                    </div>
                </InfoWindow>
            )
        }
    }


    markerPolygon = (ass) => {
        const polygon = ass.polygons.find(p => p.chosen)
        const points = polygon.polygon_points
        let averageLat = (polygon.type_polygon !== 'circle' && polygon.type_polygon !== 'polyLine')
            ? points.reduce((previousValue, currentValue, i) => {
            if (currentValue.lat) {
                if (i === 1) {
                    return previousValue.lat + currentValue.lat
                }
                return previousValue + currentValue.lat
            } else {
                if (i === 1) {
                    return previousValue.latitude + currentValue.latitude
                }
                return previousValue + currentValue.latitude
            }
        }) / points.length : ass.latitude
        let averageLng = (polygon.type_polygon !== 'circle' && polygon.type_polygon !== 'polyLine')
            ? points.reduce((previousValue, currentValue, i) => {
            if (currentValue.lng) {
                if (i === 1) {
                    return previousValue.lng + currentValue.lng
                }
                return previousValue + currentValue.lng
            } else {
                if (i === 1) {
                    return previousValue.longitude + currentValue.longitude
                }
                return previousValue + currentValue.longitude
            }
        }) / points.length : ass.longitude
        if (polygon.type_polygon === 'polyLine') {
            const index = Math.round(points.length / 2) - 1
            if (points.length % 2 !== 0) {
                averageLat = points[index].lat ? points[index].lat : points[index].latitude
                averageLng = points[index].lng ? points[index].lng : points[index].longitude
            } else {
                if (points[0].lat) {
                    averageLat = (points[index].lat + points[index + 1].lat) / 2
                    averageLng = (points[index].lng + points[index + 1].lng) / 2
                } else {
                    averageLat = (points[index].latitude + points[index + 1].latitude) / 2
                    averageLng = (points[index].longitude + points[index + 1].longitude) / 2
                }
            }

        }
        return (
            <Marker
                position={{lat: averageLat, lng: averageLng}}
                icon={getLabel(ass.label)}
                strokeColor={"#ffffff"}
                clickable={false}
                zIndex={1000}
            >
                {this.infoWindow(ass, averageLat, averageLng)}
            </Marker>
        )
    }

    setShapeOpacity = (ass) => {
        const polygon = ass.polygons.find(p => p.chosen)

        if (ass.shapeOpacity && polygon.type_polygon === 'polyLine') {
            return 0.35
        } else if (ass.shapeOpacity) {
            return 0.2
        } else if (ass.opacity && polygon.type_polygon === 'polyLine') {
            return 0.75
        } else if (ass.opacity) {
            return 0.5
        } else {
            return 1
        }
    }

    onGetLocationSuccess(position) {
        this.props.onGeolocationMarkerAdd(position.coords);
    }


    onGetLocationError(err) {
        alert(err.message)
    }


    render() {
        const {
            site,
            siteAssets,
            onMarkerAdd,
            fullScreen,
            anyMoved,
            asset,
            showLabels,
            showNewAssets,
            spriteUrl,
            markerOrigins,
            isNotMobile
        } = this.props;
        let {
            drawingMode, editable, mode, duplicates, center, mapParams, refresh, isMapLoaded, isMapView,
            showMyLocation,
            myLocationMarker
        } = this.state;
        editable = editable || this.props.editable;
        if (site === undefined) {
            return <span>Map appears when a Site is selected</span>
        }
        //DEPRECATED
        if (center) {
            this.setState({center: false});
        }

        if (mapParams && site && siteAssets?.length > 0) {
            mapParams.streetViewControl = true
            if (this.map) {
                const panorama = this.map.getStreetView()

                google.maps.event.addListener(panorama, 'visible_changed', () => {
                    if (panorama.getVisible()) {
                        this.setState({isMapView: false})
                    } else {
                        this.setState({isMapView: true})
                    }
                })
            }
        }

        return (
            mapParams && site ? <div>
                <GoogleMapLoader
                    containerElement={
                        <div
                            id="leadMap"
                            className="lead-map"
                            style={{
                                height: "83vh",
                                width: "100%"
                            }}
                        />
                    }
                    googleMapElement={
                        <GoogleMap
                            {...mapParams}

                            options={{
                                fullscreenControl: true,
                                gestureHandling: isMobile ? 'greedy' : 'auto',
                                clickableIcons: false,
                                disableDoubleClickZoom: isMobile
                            }}
                            onIdle={() => {
                                if (!isMapLoaded) {
                                    this.reloadMapParams()
                                    this.setState({isMapLoaded: true})
                                }
                            }}
                            ref={it => {
                                this.map = it;
                            }}
                        >
                            {editable &&
                                <DrawingManager
                                    drawingMode={drawingMode}
                                    defaultOptions={{
                                        drawingControl: true,
                                        drawingControlOptions: {
                                            position: google.maps.ControlPosition.TOP_CENTER,
                                            drawingModes: [
                                                MAP_DRAWING_MODES.MARKER,
                                                'SearchBox',
                                                MAP_DRAWING_MODES.POLYLINE,
                                                MAP_DRAWING_MODES.POLYGON,
                                                MAP_DRAWING_MODES.RECTANGLE,
                                                MAP_DRAWING_MODES.CIRCLE

                                            ],
                                        },

                                        polylineOptions: {
                                            strokeColor: '#ff0000',
                                            strokeWeight: isMobile ? 4 : 2,
                                            editable: false
                                        },
                                        polygonOptions: {
                                            strokeColor: '#0000ff',
                                            strokeWeight: isMobile ? 3 : 2,
                                            fillColor: '#0000ff',
                                            fillOpacity: 0.2,
                                            editable: false
                                        },
                                        rectangleOptions: {
                                            strokeColor: '#ff0000',
                                            strokeWeight: isMobile ? 3 : 2,
                                            fillColor: '#ff0000',
                                            fillOpacity: 0.2,
                                            editable: false
                                        },
                                        circleOptions: {
                                            strokeColor: '#ff0000',
                                            strokeWeight: isMobile ? 3 : 2,
                                            fillColor: '#ff0000',
                                            fillOpacity: 0.2,
                                            editable: false
                                        }
                                    }}
                                    onMarkerComplete={marker => {
                                        if (mode === 'duplication') {
                                            duplicates.push(marker);
                                        } else {
                                            marker.setMap(null);
                                            this.setState({drawingMode: 'marker'});
                                            onMarkerAdd(marker);
                                        }
                                    }}
                                    onPolylineComplete={mode === 'measuring' ? this.onMeasureComplete : this.onPolyLineComplete}
                                    onPolygonComplete={this.drawingSave}
                                    onCircleComplete={this.drawCircle}
                                    onRectangleComplete={this.drawRectangle}
                                    onDrawingModeChange={nextDrawingMode => {
                                        if (drawingMode !== nextDrawingMode) {
                                            this.setState({drawingMode: nextDrawingMode});
                                        }
                                        if (mode === 'measuring' && nextDrawingMode !== MAP_DRAWING_MODES.POLYLINE) {
                                            this.setState({mode: null});
                                        }
                                    }}
                                />
                            }
                            {!anyMoved && isMapLoaded &&
                                <Button bsStyle={mode === 'measuring' ? "primary" : 'light'}
                                        className={`${fullScreen && isNotMobile && 'mr-10'} btn-measure`}
                                        onClick={() => {
                                            if (this.state.mode === 'duplication') {
                                                this.finishDuplication()
                                            }
                                            const newMode = mode === 'measuring' ? null : 'measuring';
                                            this.setState({
                                                    mode: mode === 'measuring' ? null : 'measuring',
                                                    drawingMode: mode === 'measuring' ? null : MAP_DRAWING_MODES.POLYLINE
                                                }
                                            )
                                        }}>
                                    <FontAwesomeIcon icon={faRuler}/></Button>}
                            {isMapLoaded && <>{!this.state.lockedMode ? <Button bsStyle={'light'}
                                                                                className={`${fullScreen && isNotMobile ? 'mr-20' : 'mr-20'} btn-lock`}
                                                                                onClick={() => {
                                                                                    if (this.state.mode === 'duplication') {
                                                                                        this.finishDuplication()
                                                                                    }
                                                                                    this.setState({
                                                                                            lockedMode: !this.state.lockedMode,
                                                                                            editable: false,
                                                                                            mode: 'null'
                                                                                        },
                                                                                        this.props.onToggleLock)
                                                                                }}>
                                    <FontAwesomeIcon size={8} icon={faLockOpen}/></Button>
                                : <Button bsStyle={'light'}
                                          className={`${fullScreen && isNotMobile ? 'mr-20' : 'mr-20'} btn-lock`}
                                          onClick={() => {
                                              if (this.state.mode === 'duplication') {
                                                  this.finishDuplication()
                                              }
                                              this.setState({lockedMode: !this.state.lockedMode},
                                                  this.props.onToggleLock)
                                          }}>
                                    <FontAwesomeIcon size={8} icon={faLock}/></Button>}</>}
                            {isMobile && isMapLoaded && <Button bsStyle={'light'}
                                                                className={`${fullScreen && isNotMobile ? 'mr-20' : 'mr-20'} btn-add-marker ${showNewAssets ? 'new-assets' : ''}`}
                                                                onClick={() => {
                                                                    if (!navigator.geolocation) {
                                                                        alert(`Your browser doesn't support Geolocation`)
                                                                    } else {
                                                                        navigator.geolocation.getCurrentPosition((position) => this.onGetLocationSuccess(position), (err) => this.onGetLocationError(err));
                                                                    }
                                                                }}>
                                <FontAwesomeIcon size={8} icon={faMapMarkerAlt}/></Button>}
                            {showNewAssets && <Button bsStyle={'light'}
                                                      className={`${fullScreen && isNotMobile ? 'mr-20' : 'mr-20'} legend-btn`}
                                                      onClick={() => {
                                                          this.setState({showLegend: !this.state.showLegend})
                                                      }}>
                                <FontAwesomeIcon icon={faInfoCircle}/></Button>}

                            {this.state.showLegend && showNewAssets && <ul className='legend'>
                                <b>Legend</b>
                                <li><img src={getColorIcon('#f8e500', false, 1, false, false).url} height="35"/>
                                    <p>Not completed</p>
                                </li>
                                <li><img src={getColorIcon('#f8e500', false, 1, true, false).url} height="35"/>
                                    <p>Completed this year</p>
                                </li>
                                <li><img src={getColorIcon('#f8e500', false, 1, true, true).url} height="35"/>
                                    <p>Completed in previous years</p>
                                </li>
                            </ul>}
                            {this.state.distance
                                ? <InfoWindow
                                    onCloseClick={this.toggleInfoWindow}
                                    position={this.state.position}
                                >
                                    <div>
                                        {this.state.distance}
                                    </div>
                                </InfoWindow>
                                : null}

                            {refresh && siteAssets.map((ass) => {
                                const polygon = ass.polygons.find(p => p.chosen)
                                const selectedAssets = this.getSelectedAssets().map(x => x.id);

                                if (!isMapView) {
                                    this.onSteetViewChange(siteAssets)
                                }

                                if (polygon && polygon.type_polygon !== 'marker' && isMapView) {
                                    const color = polygon.color ? colors[polygon.color] : colors[parseInt(ass.plant_color)]
                                    const opacity = this.setShapeOpacity(ass)

                                    if (polygon.type_polygon === 'circle') {
                                        return (<Circle
                                            ref={ref => ref && (this.shapeRefs[ass.id] = ref)}
                                            defaultOpacity={1}
                                            onClick={() => this.onMarkerClick(ass, 'circle')}
                                            center={{
                                                lat: polygon.polygon_points[0].lat,
                                                lng: polygon.polygon_points[0].lng
                                            }}
                                            editable={mode === 'resize' && selectedAssets.includes(ass.id) && this.state.selectedAsset !== null && !this.state.lockedMode}
                                            draggable={!this.state.lockedMode}
                                            options={{
                                                clickable: true,
                                                fillOpacity: opacity,
                                                strokeColor: color,
                                                fillColor: color
                                            }}
                                            radius={polygon.radius}
                                            key={ass.id}
                                            onDragStart={this.stopDrawing}
                                            onDrag={() => this.onCircleMove(ass)}
                                            onDragEnd={() => this.onCircleMove(ass)}
                                            onRadiusChanged={() => this.onCircleEdit(ass)}
                                        />)
                                    } else if (polygon.type_polygon === 'polyLine') {
                                        return (
                                            <React.Fragment key={ass.id}>
                                                <Polyline
                                                    path={polygon.polygon_points}
                                                    options={{
                                                        clickable: false,
                                                        strokeOpacity: opacity,
                                                        strokeColor: color
                                                    }}
                                                />
                                                <Polyline
                                                    ref={ref => ref && (this.shapeRefs[ass.id] = ref)}
                                                    onMouseUp={() => this.onShapeChange(ass)}
                                                    onClick={() => this.onMarkerClick(ass, 'polyLine')}
                                                    path={polygon.polygon_points}
                                                    onDragStart={this.stopDrawing}
                                                    onDrag={() => this.onShapeChange(ass)}
                                                    onDragEnd={() => this.onShapeChange(ass)}
                                                    options={{
                                                        clickable: true,
                                                        strokeColor: color,
                                                        strokeOpacity: 0.01,
                                                        strokeWeight: 16,
                                                        zIndex: 1
                                                    }}
                                                    editable={mode === 'resize' && selectedAssets.includes(ass.id) && this.state.selectedAsset !== null && !this.state.lockedMode}
                                                    draggable={!this.state.lockedMode}
                                                />
                                            </React.Fragment>
                                        )
                                    } else if (polygon.type_polygon === 'rectangle' && checkRectangleCoordinates(polygon)) {
                                        return (<Rectangle
                                            ref={ref => ref && (this.shapeRefs[ass.id] = ref)}
                                            onMouseUp={() => this.onShapeChange(ass)}
                                            onClick={() => this.onMarkerClick(ass, 'rectangle')}
                                            bounds={{
                                                north: polygon.polygon_points[0].lat || polygon.polygon_points[0].latitude,
                                                south: polygon.polygon_points[3].lat || polygon.polygon_points[3].latitude,
                                                east: polygon.polygon_points[1].lng || polygon.polygon_points[1].longitude,
                                                west: polygon.polygon_points[0].lng || polygon.polygon_points[0].longitude,
                                            }}
                                            key={ass.id}
                                            onDragStart={this.stopDrawing}
                                            onBoundsChanged={() => this.onShapeChange(ass)}
                                            options={{
                                                clickable: true,
                                                fillOpacity: opacity,
                                                strokeColor: color,
                                                fillColor: color
                                            }}
                                            editable={mode === 'resize' && selectedAssets.includes(ass.id) && this.state.selectedAsset !== null && !this.state.lockedMode}
                                            draggable={!this.state.lockedMode}
                                        />)
                                    } else {
                                        return (<Polygon
                                            ref={ref => ref && (this.shapeRefs[ass.id] = ref)}
                                            onMouseUp={() => this.onShapeChange(ass)}
                                            onClick={() => this.onMarkerClick(ass, 'polygon')}
                                            path={polygon.polygon_points}
                                            key={ass.id}
                                            onDragStart={this.stopDrawing}
                                            onDrag={() => this.onShapeChange(ass)}
                                            onDragEnd={() => this.onShapeChange(ass)}
                                            options={{
                                                clickable: true,
                                                fillOpacity: opacity,
                                                strokeColor: color,
                                                fillColor: color
                                            }}
                                            editable={mode === 'resize' && selectedAssets.includes(ass.id) && this.state.selectedAsset !== null && !this.state.lockedMode}
                                            draggable={!this.state.lockedMode}
                                        />)
                                    }
                            } else {
                                if (!spriteUrl || !markerOrigins) {
                                    return null
                                }

                                    if (!isMapView) {
                                        ass.latitude = ass.lat
                                        ass.longitude = ass.lng
                                        if (ass.polygons?.length > 0) {
                                            ass.plant_color = polygon.color ? polygon.color : ass.plant_color
                                        }
                                        ass.polygons = []
                                    }

                                    const origin = markerOrigins[ass.id]?.origin;
                                    let icon = undefined
                                    if (origin) {
                                        icon = {
                                            url: spriteUrl,
                                            size: new google.maps.Size(30, 45),
                                            origin: new google.maps.Point(origin.x, origin.y),
                                            anchor: new google.maps.Point(15, 45),
                                        }
                                    }
                                    return <MemoizedMarker
                                        isSelected={selectedAssets.includes(ass.id) && this.state.selectedAsset !== null}
                                        duplicating={selectedAssets.includes(ass.id) && this.state.selectedAsset !== null && mode === "duplication"}
                                        key={ass.id}
                                        editable={editable}
                                        ass={ass} icon={icon}
                                        showNewAssets={showNewAssets}
                                        lockedMode={this.state.lockedMode}

                                        infoWindow={this.infoWindow}
                                        onDragend={m => this.onDragend(m)}
                                        onMarkerClick={m => this.onMarkerClick(m)}
                                    />
                                }
                            })}
                            {refresh && siteAssets.map((ass) => {
                                const polygon = ass.polygons.find(p => p.chosen)
                                if (polygon && polygon.type_polygon !== 'marker') {
                                    return (
                                        this.markerPolygon(ass)
                                    )
                                }
                            })}
                            {site && siteAssets.length === 0 &&
                                <Marker
                                    key={1}
                                    position={{lat: site.latitude, lng: site.longitude}}
                                    icon={getBasicMarker({selected: false, color: "#ff6479", label: "x"})}
                                    title={site.name}
                                />}
                            {showMyLocation && myLocationMarker &&
                                <Marker
                                    position={{lat: myLocationMarker.latitude, lng: myLocationMarker.longitude}}
                                    icon={dot}
                                    title={"Here you are!"}
                                />}
                            <PolygonModal
                                show={this.state.onHidePolygonModal}
                                onHide={this.onHidePolygonModal}
                                resource={this.state.polygonModal}
                                destoryPolygon={(polygon) => {
                                    this.props.actions.remove(polygon)
                                    this.deletePolygon(polygon)
                                }}
                                savePolygon={(resource) => this.props.actions.save(resource)}
                            />
                        </GoogleMap>
                    }
                />
                {this.props.myLocationCheckbox && <ColorCheckbox value={this.state.showMyLocation}
                                                                 onChange={(value) => {
                                                                     this.setState({checkboxLoading: true})
                                                                     this.props.actions.setUserShowLocation(value, () => {
                                                                         this.setState({
                                                                             showMyLocation: value,
                                                                             checkboxLoading: false
                                                                         })
                                                                     })
                                                                 }}
                                                                 disabled={this.state.checkboxLoading}
                                                                 label={"My Location"}
                />}
            </div> : <div
                className="lead-map margin10"
                style={{
                    textAlign: "center",
                    height: "83vh",
                    width: "97%",
                }}
            >
                <MDSpinner className="top-50" size={60}/>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        client: state.client.customerInfo
    };
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({...api, getUserShowLocation, setUserShowLocation}, dispatch),
});

const MapWithMedia = withMediaQuery(Map, {
    isNotMobile: {minWidth: 991},
});

export default memo(geolocated({
    positionOptions: {
        enableHighAccuracy: true,
    },
    userDecisionTimeout: 5000,
})(connect(mapStateToProps, mapDispatchToProps)(MapWithMedia)), areAssetsEquals)
